<template>
  <div
    class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2"
  >
    <!-- imagem de perfil, editar para deixar redonda -->
    <div class="flex align-center justify-center mt-6">
      <img src="@/assets/perfil.png" alt="" class="w-1/2" />
    </div>
    <!-- texto -->
    <div class="mt-16">
      <h1 class="font-sedgwick text-3xl text-center text-[#f8f7f2]">Sobre</h1>

      <p class="lg:text-lg sm:text-sm p-6 text-justify text-[#f8f7f2]">
        Técnico em Informática e Desenvolvedor Full-Stack com preferência pelo
        Server-Side. Domínio nas linguagens JavaScript e Python e no uso de
        bancos de dados como MySQL e MongoDB, mas com facilidade em aprender
        novas tecnologias. Em busca do primeiro emprego para colaborar com meu
        crescimento profissional e da instituição a qual estiver vinculado.
      </p>
    </div>
  </div>

  <!-- formação acadêmica -->
  <Timeline />
  <!-- ferramentas e tecnologias -->
  <Ferramentas />
</template>

<script>
import Ferramentas from "@/components/Ferramentas.vue";
import Timeline from "@/components/Timeline.vue";
export default {
  name: "Sobre",
  components: {
    Timeline,
    Ferramentas,
  },
};
</script>

<style>
</style>